/**
 * @GENERATED from Figma node 3638:52276
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const NumbersDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#3BA0F3"
      fillRule="evenodd"
      d="M1 4.361c0-.337.274-.611.611-.611h5.195c.337 0 .61.274.61.611v3.361a.61.61 0 0 1-.61.611H1.61A.61.61 0 0 1 1 7.723zm7.792 0c0-.337.273-.611.61-.611h5.195c.338 0 .611.274.611.611v3.361a.61.61 0 0 1-.61.611H9.402a.61.61 0 0 1-.611-.61zm8.402-.611a.61.61 0 0 0-.61.611v3.361c0 .338.273.611.61.611h5.195a.61.61 0 0 0 .611-.61V4.36a.61.61 0 0 0-.611-.611zM1 10.32c0-.338.274-.612.611-.612h5.195c.337 0 .61.274.61.611v3.361a.61.61 0 0 1-.61.612H1.61A.61.61 0 0 1 1 13.68zm8.403-.612a.61.61 0 0 0-.611.611v3.361c0 .338.273.612.61.612h5.195a.61.61 0 0 0 .611-.611v-3.362a.61.61 0 0 0-.61-.61zm7.18.611c0-.337.274-.61.611-.61h5.195c.337 0 .611.273.611.61v3.361a.61.61 0 0 1-.611.612h-5.195a.61.61 0 0 1-.61-.611zM1.611 15.667a.61.61 0 0 0-.611.61v3.362c0 .337.274.611.611.611h5.195a.61.61 0 0 0 .61-.611v-3.361a.61.61 0 0 0-.61-.611zm7.18.61c0-.337.274-.61.612-.61h5.194c.338 0 .611.273.611.61v3.362a.61.61 0 0 1-.61.611H9.402a.61.61 0 0 1-.611-.611zm8.403-.61a.61.61 0 0 0-.61.61v3.362c0 .337.273.611.61.611h5.195a.61.61 0 0 0 .611-.611v-3.361a.61.61 0 0 0-.611-.611z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(NumbersDark);
export { ForwardRef as NumbersDark };
